//Home User
$(document).on('click','.carnet-avatar',function(){
    $("#camara").click();
});
$(document).on('change','#camara',function(){
    $("#formCambioAvatar").submit();
});